function setGuideNavTop() {
	// ヘッダーの高さを取得、stickyなナビゲーションの固定位置を指定
	var headerHeight = $('header').outerHeight() || 0;
	$('.guide_nav').css('top', headerHeight + 'px');
	document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
}
$(window).on('load', setGuideNavTop);
$(function() {
	setGuideNavTop();
	$(window).on('resize', setGuideNavTop);
});


$(function () {

	// スクロール時にアクティブなナビ項目をハイライト
	var $sections = $('.guide_section');
	var $navLinks = $('.guide_nav-link');

	function updateActiveNav() {
		var scrollTop = $(window).scrollTop();
		var activeId = '';

		$sections.each(function () {
			var sectionTop = $(this).offset().top - 40;
			if (scrollTop >= sectionTop) {
				activeId = '#' + $(this).attr('id');
			}
		});

		$navLinks.removeClass('is-active');
		if (activeId) {
			$navLinks.filter('[href="' + activeId + '"]').addClass('is-active');
		}
	}

	$(window).on('scroll', function () {
		updateActiveNav();
	});

	updateActiveNav();
});
